import React, { Fragment, useEffect, useState } from 'react';
import { Paper, Grid } from '@material-ui/core';
import success from './congrats.PNG';
const ActivateCardSuccess = (props) => {
  const { alertDescription } = props;
  // eslint-disable-next-line
  const [message, setMessage] = useState(alertDescription); // eslint-disable-next-line
  const successFormat = {
    border: '1px solid',
    borderRadius: '5px',
    padding: '15px',
    borderColor: 'rgb(65,178,51)',
    icon: success,    
    backgroundColor: 'rgb(234,232,232)',
    boxShadow: '0px',
  };

  const text = ["You have successfully nominated your PIN. Your Flexi Card is now ready for use. Please DO NOT DISCLOSE OR SHARE your Personal Identification Number (PIN) to anyone.",
  <br />,
  "Thank you!"]

  useEffect(() => {
    /* setTimeout(() => {
      setMessage('success');
    }, 25000); */
    setMessage('');
  }, []);

  return (
    <Fragment>
      <h1>Success</h1>
      <Paper style={successFormat}>
        <Grid container spacing={8}>
          <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
            <img
              alt=''
              src={successFormat.icon}
              style={{
                width: '35px',
                height: '35px',
                fill: 'white',
              }}
            />
          </Grid>
          <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
            <p>{text}</p>
          </Grid>
        </Grid>
      </Paper>

      <br />
    </Fragment>
  );
};

export default ActivateCardSuccess;
